import {values} from './ClientLocatorData';

const errorMessage = values['b2bwebolympia'].errorMessageClientLocator;

/**
 * Validator for ClientLocator field for Olympia users.
 * 
 * @param {any} value 
 * @returns {boolean} true
 */
export function validate(value) {
    if(value && value !==''){
        return true;
    }

    throw new Error(errorMessage);
}


// WEBPACK FOOTER //
// ./src/components/Reservation/Validators/ClientLocator.b2bwebolympia.js